<template>
  <!-- 添加群聊组件 -->
  <div class="p-absolute top-0 right-0 bottom-0 left-0 bg-black-0-2" v-show="visible">
      <div class="p-absolute m-auto top-0 right-0 bottom-0 left-0 p-t-25 r-2 bg-white shadow-5-g-400 z-index-3" style="width: 70%; height: 90%;">
          <p style="position:absolute; top:0; left:0; padding-top:5px; padding-left:10px; width:100%; text-align:left; color:#653EB3; font-size:14px;">聊天记录</p>
          <p style="width:100%; text-align:center; color:#653EB3; font-size:14px;">{{historyData.userInfoCp}}</p>
          <i class="el-icon-circle-close y-fc-999 p-absolute top-5 right-10 f-s-20 cursor-pointer" @click="close"></i>
          <div class="p-relative f-left h-100-p bg-white b-r b-c-150" style="padding-top: 51px; width:100%">
              <div class="p-absolute w-100-p top-0 left-0">
                  <div class="d-table p-x-12 w-100-p b-b b-c-g-100" style="height: 51px;">
                      <div class="d-table-cell v-a-middle">
                          <label class="p-relative d-block h-30 bg-g-100" style="border-radius: 15px;" ref="labelRef">
                              <input class="form-element b-w-0 p-x-20 w-100-p h-30 l-h-30 bg-transparent" type="text" placeholder="搜索" v-model="value" ref="inputRef">
                              <i class="el-icon-close f-s-18 l-h-30 p-absolute top-0 bottom-0 right-0 m-auto p-x-10 cursor-pointer" @click.prevent.self="clearValue" v-show="value"></i>
                          </label>
                      </div>
                  </div>
              </div>
              <div class="p-absolute top-50 left-0 w-100-p h-39 b-b b-c-g-100">
              <ul class="d-table w-100-p h-100-p">
                <li @click="changeli" class="p-relative d-table-cell h-100-p t-a-center v-a-middle cursor-pointer cursor-pointer user-select-none c-blue-hover search-tab-element" :style="{width:100/tabs.length+'%'}" v-for="item in tabs" :key="item.value" :class="{'c-blue':navSelctType===item.value}">
                  <label style="display: inline-block;width: 100%;height: 100%;line-height: 2.5;">{{item.name}}<input class="d-none" type="radio" :value="item.value" name="imNavTabRadio" v-model="navSelctType"></label>
                  <i class="d-none p-absolute left-0 right-0 m-auto h-2" :class="{'d-block':navSelctType===item.value}" style="bottom: -1px; background-color: #653EB3;" :style="{width:item.labelWidth}"></i>
                </li>
              </ul>
            </div>
            <!-- 全部 -->
            <div class="o-auto m-t-50 p-b-20 left-personnel-box historyScrollContainer" style="height:92%;background: #eee;">
              <div v-if="ulHeight" class="t-a-center" style="margin: 68px auto auto;">
                <img src="@/assets/images/im/kong-order@2x.png" width="155px" height="104px"/>
              </div>
              <div  v-if="ulHeight" class="f-s-12 t-a-center" style="color:#999999">暂无记录</div>
              <ul style="background: #eee;padding-top:0.1px;" class="historyScroll">
                <li class="" v-for="(item,index) in firstHistoryData" :key="index">
                <a @click="closeHistoryPanel" :href="'#'+item.idServer" style="text-decoration: none;color: #333;" v-if="!item.content">
                  <div style=" margin-top: 10px;background: #fff;width: 98%;margin-left: 10px;" class="p-y-10 flex cursor-pointer" v-if="(navSelctType==='0'&&((value&&item.text&&item.text.includes(value))||!value)) ||(navSelctType==='0'&&((value&&item.file&&item.file.name&&item.file.name.includes(value))||!value))|| (((value&&item.file&&item.file.name&&item.file.name.includes(value))||!value)&&navSelctType==='1'&&(item.file&&!(item.file.ext.toLowerCase()=='jpg'||item.file.ext.toLowerCase()=='png'|| 
                  item.file.ext.toLowerCase()=='gif'||item.file.ext.toLowerCase()=='jpeg'||item.file.ext.toLowerCase()=='bmp')))|| (((value&&item.text&&item.text.includes(value))||!value)&&navSelctType==='2'&&(item.file&&(item.file.ext.toLowerCase()=='jpg'||item.file.ext.toLowerCase()=='png'|| 
                  item.file.ext.toLowerCase()=='gif'||item.file.ext.toLowerCase()=='jpeg'||item.file.ext.toLowerCase()=='bmp')))||(((value&&item.text&&item.text.includes(value))||!value)&&navSelctType==='3'&&(item.text&&item.text.includes('www.')||item.text.includes('http:')||item.text.includes('https:')))">
                      <div class="d-table-cell v-a-middle h-100-p w-64" v-if="scenceTo.scene==='p2p'" style="text-align: center;">
                          <img src="@/assets/images/im/kefu.svg" style="width:40px;height:40px;"/>
                      </div>
                      <div class="d-table-cell v-a-middle h-100-p w-64" v-if="scenceTo.scene==='team'" style="text-align: center;">
                          <span class="d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none" v-if="(!toTeamData.avatar)||toTeamData.avatar=='avatar'||toTeamData.avatar==''" style="background-color: rgb(255, 204, 0);">群聊</span>
                          <img v-else :src="toTeamData.avatar" style="width:40px;height:40px;"/>
                      </div>
                      <div class="content" style="width:91%;">
                        <div class="flex header" style="color:#999">
                            <div class="w-80 w-s-nowrap t-o-ellipsis o-hidden">{{item.fromNick}}</div>
                            <div>{{format(item.time,0)}}</div>
                        </div>
                        <div class="m-r-4 m-t-10" style="width:94%;word-break: break-all;" v-if="navSelctType==='0'&&item.text">
                          <p v-if="item.text.includes('www.')||item.text.includes('http:')||item.text.includes('https:')" style="color:#653EB3;" >{{item.text}}</p>
                          <p v-else>{{item.text}}</p>
                        </div>
                        <div class="m-r-4 m-t-10" style="width:94%;word-break: break-all;" v-if="navSelctType==='3'&&item.text&&(item.text.includes('www.')||item.text.includes('http:')||item.text.includes('https:'))">
                          <p style="color:#653EB3;">{{item.text}}</p>
                        </div>
                        <div class="m-r-4 m-t-10 w-s-nowrap t-o-ellipsis o-hidden" v-if="(navSelctType==='2'||navSelctType==='0')&&item.file&&item.file.url&&(item.file.ext.toLowerCase()=='jpg'||item.file.ext.toLowerCase()=='png'||item.file.ext.toLowerCase()=='gif'||item.file.ext.toLowerCase()=='jpeg'||item.file.ext.toLowerCase()=='bmp')">
                          <img  :src="item.file.url"  v-if="item.file.ext.toLowerCase()=='jpg'||item.file.ext.toLowerCase()=='png'||item.file.ext.toLowerCase()=='gif'||item.file.ext.toLowerCase()=='jpeg'||item.file.ext.toLowerCase()=='bmp'" style="width:100px;height:100px;"/>
                        </div>
                        <div class="m-r-4 m-t-10 w-s-nowrap t-o-ellipsis o-hidden" v-if="(navSelctType==='1'||navSelctType==='0')&&item.file&&item.file.url&&!(item.file.ext.toLowerCase()=='jpg'||item.file.ext.toLowerCase()=='png'||item.file.ext.toLowerCase()=='gif'||item.file.ext.toLowerCase()=='jpeg'||item.file.ext.toLowerCase()=='bmp')">
                          <video  class="cursor-pointer" controls="true" style="width: 200px; height: 200px;" v-if="(item.file&&(item.file.ext.toLowerCase() == 'mp4' || item.file.ext.toLowerCase() == 'ogv'||item.file.ext.toLowerCase() == 'webm'||item.file.ext.toLowerCase() == 'ogg'||item.file.ext.toLowerCase() == 'mov'||item.file.ext.toLowerCase() == 'mkv'))">
                            <source type="video/mp4" :src="item.file.url">
                            <source type="video/ogg" :src="item.file.url">
                            <source type="video/webm" :src="item.file.url">
                          </video>
                          <audio  class="cursor-pointer" controls="true" style="width: 200px; height: 40px;" v-else-if="(item.file&&(item.file.ext.toLowerCase() == 'aac' || item.file.ext.toLowerCase() == 'mp3'||item.file.ext.toLowerCase() == 'wav'||item.file.ext.toLowerCase() == 'amr'||item.file.ext.toLowerCase() == 'mpeg'||item.file.ext.toLowerCase() == 'midi'))">
                            <source type="audio/ogg" :src="item.file.url">
                            <source type="audio/mpeg" :src="item.file.url">
                            <source type="audio/wav" :src="item.file.url">
                          </audio>
                          <div v-else>
                            <img src="/new@/assets/images/im/filelog.png" style="width: 28px; height: 36px;">
                            <span>{{item.file.name}}</span>
                            <span>{{changeByte(item.file.size)}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    </a>
                </li>
              </ul>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    teamlevel: {
      type: Number,
      default: 200
    },
    historyData:{
      type: Object,
      default: function () {
        return {};
      }
    },
    scenceTo:{
      type: Object,
      default: function () {
        return {};
      }
    },
    myAccountData:{
      type: Object,
      default: function () {
        return {};
      }
    },
    toCustomData:{
      type: Object,
      default: function () {
        return {};
      }
    },
    toTeamData:{
      type: Object,
      default: function () {
        return {};
      }
    },
    firstHistoryData:{
      type: Array,
      default: function () {
        return [];
      }
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    im: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data: function () {
    return {
      ulHeight:false,
      visible: false,
      scrollflag:true,
      value: '',
      navSelctType: '0',
      oldScrollTop:0,
      tabs: [
        { value: '0', name: '全部', labelWidth: '44px' },
        { value: '1', name: '文件', labelWidth: '45px' },
        { value: '2', name: '图片', labelWidth: '44px' },
        { value: '3', name: '链接', labelWidth: '44px' }
      ],
    };
  },
  components: {
  },
  mounted: function () {
    this.historyScrolldom();
  },
  methods: {
    getCounldData(){
      let len = this.firstHistoryData.length;
      let endTimes = null;
      if(len){
        endTimes = this.firstHistoryData[len-1].time;
      }else{
        return;
      }
      let $this = this;
      $this.im.getHistoryMsgs({
        scene: $this.scenceTo.scene||'',
        to:  $this.scenceTo.to,
        limit:100,
        reverse:false,
        endTime:endTimes,
        done: function(err, data){
          if(err) return $this.scrollflag = true;
          if(data.msgs.length>1){
            data.msgs.shift()
            $this.firstHistoryData.push(...data.msgs)
            $this.scrollflag = true;
          }
        }
      })
    },
    historyScrolldom(){
      this.$nextTick(()=>{
        let historyScrolldom = document.querySelector(".historyScroll");
        let historyScrollContainer = document.querySelector(".historyScrollContainer");
        this.scrollflag = true;
        historyScrolldom.addEventListener('mousewheel',()=>{
          let scrollHeight = historyScrolldom.scrollHeight;
          let clientHeight = historyScrollContainer.clientHeight;
          let scrollTop = historyScrollContainer.scrollTop;
         
          if(scrollHeight <= clientHeight+scrollTop+20){
            if(this.scrollflag && this.oldScrollTop < scrollTop){
              this.scrollflag = false;
              this.oldScrollTop = scrollTop;
              this.getCounldData()
            }
          } 
          })
      })
     
    },
    changeli(time=0){
      setTimeout(()=>{
        let historyScrolldom = document.querySelector(".historyScroll");
        if(historyScrolldom.clientHeight < 5){
          this.ulHeight = true;
        }else{
          this.ulHeight = false;
        }
      },time)
    },
    // 活动加载历史记录数据
    
    closeHistoryPanel(){
      this.close();
    },
    // 清空表单值
    clearValue: function () {
      this.value = '';
    },
    // 打开、关闭组件
    open () {
      console.log(123)
      if (this.visible) return;
      this.visible = true;
      this.navSelctType = '0';
      this.ulHeight = false;
      this.scrollflag = true;
      this.oldScrollTop = 0;
      this.changeli(1000);
      // this.crearePrivateTeam();
    },
    close: function () {
      this.oldScrollTop = 0;
      this.visible = false;
      // 重置选择组件
      this.value = '';
    },
    format: function (timestamp,type) {
      //time是整数，否则要parseInt转换
      var time = new Date(timestamp),
        nowDate = new Date(),
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        mm = time.getMinutes(),
        s = time.getSeconds();
      if (y + "" + m + "" + d + "" == nowDate.getFullYear()+""+(nowDate.getMonth()+1)+""+nowDate.getDate()) {
        if(type == 0){
          return "今天"
        }else if(type == 1){
          return this.add(h) + ':' + this.add(mm) + ':' + this.add(s)
        }
      }
      return y + '-' + this.add(m) + '-' + this.add(d)+'  '+this.add(h) + ':' + this.add(mm) + ':' + this.add(s);
  },
  add: function (m) {
    return m < 10 ? '0' + m : m
  },
  changeByte:function (limit){
    var size = "";
    if(limit < 0.1 * 1024){                            //小于0.1KB，则转化成B
        size = limit.toFixed(2) + "B"
    }else if(limit < 0.1 * 1024 * 1024){            //小于0.1MB，则转化成KB
        size = (limit/1024).toFixed(2) + "KB"
    }else if(limit < 0.1 * 1024 * 1024 * 1024){        //小于0.1GB，则转化成MB
        size = (limit/(1024 * 1024)).toFixed(2) + "MB"
    }else{                                            //其他转化成GB
        size = (limit/(1024 * 1024 * 1024)).toFixed(2) + "GB"
    }

    var sizeStr = size + "";                        //转成字符串
    var index = sizeStr.indexOf(".");                    //获取小数点处的索引
    var dou = sizeStr.substr(index + 1 ,2)            //获取小数点后两位的值
    if(dou == "00"){                                //判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
    }
    return size;
  },
  },
  watch: {
    value(val){
      this.changeli();
    }
  },
  computed: {}
}
</script>
